var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16757_536842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7855 8.21717L7.99447 10.8165C7.955 10.8461 7.90724 10.8631 7.85714 10.8653C7.80703 10.8675 7.7568 10.8549 7.71267 10.8291L4.08443 8.70743C3.97647 8.64439 3.88768 8.55234 3.82863 8.44223C3.76958 8.33211 3.74277 8.20859 3.75139 8.08636C3.76001 7.96413 3.80369 7.84835 3.87724 7.7528C3.95079 7.65726 4.0511 7.58599 4.16622 7.54747L15.3835 3.7832C15.4968 3.74509 15.6199 3.7403 15.7385 3.76939C15.8571 3.79848 15.9663 3.86026 16.0536 3.94757C16.1409 4.03489 16.2027 4.14418 16.2317 4.2628C16.2608 4.38142 16.256 4.50453 16.2179 4.61789L12.4549 15.8389C12.4164 15.954 12.3452 16.0543 12.2497 16.1278C12.1543 16.2013 12.0386 16.245 11.9165 16.2537C11.7944 16.2624 11.6709 16.2356 11.5609 16.1766C11.4508 16.1177 11.3588 16.029 11.2957 15.9211L9.92532 13.5761",
    stroke: "#0E4195",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16757_536842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default ForwardRef;